import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromReducer from './../state/reducers';
import { Alert } from './model/alert';

@Component({
  selector: 'ats-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AlertComponent implements OnInit {
  constructor(private store: Store<fromReducer.State>) { }
  @Input() alert: Alert;
  @Output() closeAlert = new EventEmitter();
  timer;
  alert$: Observable<Alert>;

  ngOnInit(): void { }

  ngOnChanges() : void{
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.close(), 8000);
  }

  close() {
    this.closeAlert.emit();
  }
}
